import { Field, ImageField, LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  ImagePropertiesParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type C17SideMediaAssetProps = RenderingProps<
  {
    Headline?: Field<string>;
    SupportCopy?: RichTextField;
    Image?: ImageField;
    VideoId?: Field<string>;
    ImageCaption?: RichTextField;
    ImageCtaLink?: LinkField;
  },
  {
    HeadlineTag?: string;
    ImageSide?: string;
    ImageBorderOn?: string;
    ImageContainerSize?: string;
  } & TranslationOptionsParams &
    AnchorTargetParams &
    ImagePropertiesParams
>;
